import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import WSDateField from "../../Components/DateField/WSDateField";
import { useForm } from "react-hook-form";
import WSTextField, {
  CurrencyType,
  TextType,
} from "../../Components/TextBox/WSTextBox";
import WSSelectField from "../../Components/Select/WSSelect";
import config from "../../Config/clientConfig.json";
import { WSIcons } from "../../commonFunctions/iIcons";

export const Payment: React.FC<any> = React.memo((props) => {
  const { control, register } = useForm();

  return (
    <Grid container sx={{ mt: 2 }} spacing={2}>
      <Grid item xs={12} sm={3}>
        <Typography gutterBottom mb={1.6} fontSize={"0.875rem"}>
          Payment Date
        </Typography>
        <WSDateField
          id="paymentdate"
          name="paymentdate"
          dateFormat="D/MM/YYYY"
          control={control}
          defaultValue={null}
          rules={{ required: false }}
          labelType="Normal"
          label={""}
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <WSTextField
          label={"Amount Paid"}
          {...register("amountpaid")}
          id="amountpaid"
          name="amountpaid"
          control={control}
          rules={{ required: false }}
          labelType="Normal"
          type={TextType.Currency}
          currency={CurrencyType.Dollar}
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <WSTextField
          label={"Gratuity"}
          {...register("Gratuity")}
          id="Gratuity"
          name="Gratuity"
          control={control}
          rules={{ required: false }}
          labelType="Normal"
          type={TextType.Currency}
          currency={CurrencyType.Dollar}
        />
      </Grid>

      {/* Table and Box in the same row */}
      <Grid container item xs={12} sm={9}>
        {/* Payment Type Table */}
        <Grid item xs={12} sm={4}>
          <TableContainer component={Paper} sx={{ width: "100%" }}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell align="center">Cash</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center">Room Posting</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center">Gift Card</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={12} sm={8}>
          <Grid
            container
            sx={{
              bgcolor: "#f0f0f0", // Background color for the box
              padding: 2, // Padding inside the box
              border: "1px solid grey",
              display: "flex", // Use flexbox
              flexDirection: "column", // Arrange fields vertically
              gap: 2, // Add space between the two fields
              width: "32rem",
              height: "100vh",
            }}
          >
            <Grid
              container
              sx={{
                display: "flex",
                alignItems: "center", // Vertically align items
              }}
            >
              <Typography sx={{ marginRight: 2 }}>Payment Type</Typography>

              <Grid sx={{ flexGrow: 1, marginRight: 2 }}>
                <WSSelectField
                  rules={{ required: true }}
                  {...register("payment")}
                  id="payment"
                  control={control}
                  defaultValue={"0"}
                  label=""
                  name="payment"
                  options={config.paymentTypeconfig.staticOptionData}
                />
              </Grid>

              <WSIcons.CreditCardIcon />
            </Grid>
            <Grid
              container
              sx={{
                display: "flex",
                alignItems: "center", 
              }}
            >
              <Typography sx={{ marginRight: 5 }}>Receipt No</Typography>
              <Grid sx={{ flexGrow: 1, marginRight: 2 }}>
                <WSTextField
                  label=""
                  {...register("receipt")}
                  id="receipt"
                  name="receipt"
                  control={control}
                  rules={{ required: false }}
                  labelType="Normal"
                />
              </Grid>
              <WSIcons.ReceiptIcon />
            </Grid>
            <Grid
              sx={{
                bgcolor: "#d3d3d3", 
                padding: "8px", 
                marginTop: 15, 
                borderTop: "1px solid grey", 
              }}
            >
              <Typography
                sx={{
                  fontWeight: "bold", 
                }}
              >
                Cash Information
              </Typography>
            </Grid>
            <Grid
              container
              sx={{
                display: "flex",
                alignItems: "center", // Vertically align items
              }}
            >
              {/* Payment Type Label */}
              <Typography sx={{ marginRight: 2 }}>Select Currency</Typography>

              {/* Wrapper for WSSelectField */}
              <Grid sx={{ flexGrow: 1, marginRight: 2 }}>
                <WSSelectField
                  rules={{ required: true }}
                  {...register("payment")}
                  id="payment"
                  control={control}
                  defaultValue={"0"}
                  label=""
                  name="payment"
                  options={config.paymentTypeconfig.staticOptionData}
                />
              </Grid>
            </Grid>
            <Grid
              container
              sx={{
                display: "flex",
                alignItems: "center", // Vertically align items
              }}
            >
              {/* Payment Type Label */}
              <Typography sx={{ marginRight: 2 }}>1 $ = 1 $ </Typography>
            </Grid>{" "}
            <Grid
              container
              sx={{
                display: "flex",
                alignItems: "center", // Vertically align items
              }}
            >
              {/* Receipt No Label */}
              <Typography sx={{ marginRight: 7 }}>Receipt No </Typography>

              {/* Wrapper for WSTextField */}
              <Grid sx={{ flexGrow: 1, marginRight: 2 }}>
                <WSTextField
                  label=""
                  {...register("receipt")}
                  id="receipt"
                  name="receipt"
                  control={control}
                  rules={{ required: false }}
                  labelType="Normal"
                  type={TextType.Currency}
                  currency={CurrencyType.Dollar}
                />
              </Grid>

              
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
});
